import { render, staticRenderFns } from "./preview_artwork2.vue?vue&type=template&id=43f0a074&scoped=true&"
import script from "./preview_artwork2.vue?vue&type=script&lang=js&"
export * from "./preview_artwork2.vue?vue&type=script&lang=js&"
import style0 from "./preview_artwork2.vue?vue&type=style&index=0&id=43f0a074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0a074",
  null
  
)

export default component.exports